import { render, staticRenderFns } from "./Twitter.vue?vue&type=template&id=556f1452"
import script from "./Twitter.vue?vue&type=script&lang=ts"
export * from "./Twitter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports